import renewalApi from '@/api/renewal';

const state = {
    list: null,
    renewalInfo: null,
    listPackages: null,
    isLoading: false,
    renewalList:null,
    membersRenewalList:null,
    validationErrors: null,
    renewalList:null
}

export const mutationTypes = {
    getPackageNodealsStart: '[packageNodeals] Get package nodeals start',
    getPackageNodealsSuccess: '[packageNodeals] Get package nodeals success',
    getPackageNodealsFailure: '[packageNodeals] Get package nodeals failure',

    getMembershipNodealsStart: '[membershipNodeals] Get membership nodeals start',
    getMembershipNodealsSuccess: '[membershipNodeals] Get membership nodeals success',
    getMembershipNodealsFailure: '[membershipNodeals] Get membership nodeals failure',

    getPackageExtensionStart: '[packageExtension] Get package extension start',
    getPackageExtensionSuccess: '[packageExtension] Get package extension success',
    getPackageExtensionFailure: '[packageExtension] Get package extension failure',
    
    getMembershipExtensionStart: '[membershipExtension] Get membership extension start',
    getMembershipExtensionSuccess: '[membershipExtension] Get membership extension success',
    getMembershipExtensionFailure: '[membershipExtension] Get membership extension failure',

    getRenewalNotaskDealsStart: '[renewalNotaskDeals] Get renewal notask deals start',
    getRenewalNotaskDealsSuccess: '[renewalNotaskDeals] Get renewal notask deals success',
    getRenewalNotaskDealsFailure: '[renewalNotaskDeals] Get renewal notask deals failure',

    getRenewalActiveDealsStart: '[renewalActiveDeals] Get renewal active deals start',
    getRenewalActiveDealsSuccess: '[renewalActiveDeals] Get renewal active deals success',
    getRenewalActiveDealsFailure: '[renewalActiveDeals] Get renewal active deals failure',

    getRenewalInfoStart: '[renewalInfo] Get renewal info start',
    getRenewalInfoSuccess: '[renewalInfo] Get renewal info success',
    getRenewalInfoFailure: '[renewalInfo] Get renewal info failure',

    getRenewalNewTasksStart: '[renewalNewTasks] Get new tasks start',
    getRenewalNewTasksSuccess: '[renewalNewTasks] Get new tasks success',
    getRenewalNewTasksFailure: '[renewalNewTasks] Get new tasks failure',

    getRenewalOverdueTasksStart: '[renewalOverdueTasks] Get overdue tasks start',
    getRenewalOverdueTasksSuccess: '[renewalOverdueTasks] Get overdue tasks success',
    getRenewalOverdueTasksFailure: '[renewalOverdueTasks] Get overdue tasks failure',

    getDealsStageRenewalStart: '[dealsStageRenewal] Get deals stage start renewal',
    getDealsStageRenewalSuccess: '[dealsStageRenewal] Get deals stage success renewal',
    getDealsStageRenewalFailure: '[dealsStageRenewal] Get deals stage failure renewal',
}

export const renewalActionTypes = {
    getPackageNodeals: '[packageNodeals] Get package nodeals list',
    getMembershipNodeals: '[membershipNodeals] Get membership nodeals list',
    getPackageExtension: '[packageExtension] Get package extension list',
    getMembershipExtension: '[membershipExtension] Get membership extension list',
    getRenewalNotaskDeals: '[renewalNotaskDeals] Get notask deals list',
    getRenewalActiveDeals: '[renewalActiveDeals] Get renewal active deals list',
    getRenewalInfo: '[renewalInfo] Get renewal',
    getRenewalNewTasks: '[renewalNewTasks] Get new tasks',
    getRenewalOverdueTasks: '[renewalOverdueTasks] Get overdue tasks',
    getListTask: '[listTask] Get list task',
    getDealsStageRenewal: '[dealsStageRenewal] Get deals stage renewal'
}

const mutations = {

    [mutationTypes.getPackageNodealsStart](state) {
        state.isLoading = true
        state.listPackages = null
    },
    [mutationTypes.getPackageNodealsSuccess](state, payload) {
        state.isLoading = false
        state.listPackages = payload
        state.validationErrors = null
    },
    [mutationTypes.getPackageNodealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getMembershipNodealsStart](state) {
        state.isLoading = true
        state.membersRenewalList = null
    },
    [mutationTypes.getMembershipNodealsSuccess](state, payload) {
        state.isLoading = false
        state.membersRenewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getMembershipNodealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getPackageExtensionStart](state) {
        state.isLoading = true
        state.listPackages = null
    },
    [mutationTypes.getPackageExtensionSuccess](state, payload) {
        state.isLoading = false
        state.listPackages = payload
        state.validationErrors = null
    },
    [mutationTypes.getPackageExtensionFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getMembershipExtensionStart](state) {
        state.isLoading = true
        state.membersRenewalList = null
    },
    [mutationTypes.getMembershipExtensionSuccess](state, payload) {
        state.isLoading = false
        state.membersRenewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getMembershipExtensionFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRenewalNotaskDealsStart](state) {
        state.isLoading = true
        state.renewalList = null
    },
    [mutationTypes.getRenewalNotaskDealsSuccess](state, payload) {
        state.isLoading = false
        state.renewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getRenewalNotaskDealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRenewalActiveDealsStart](state) {
        state.isLoading = true
        state.renewalList = null
    },
    [mutationTypes.getRenewalActiveDealsSuccess](state, payload) {
        state.isLoading = false
        state.renewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getRenewalActiveDealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRenewalInfoStart](state) {
        state.isLoading = true
        state.renewalInfo = null
    },
    [mutationTypes.getRenewalInfoSuccess](state, payload) {
        state.isLoading = false
        state.renewalInfo = payload
        state.validationErrors = null
    },
    [mutationTypes.getRenewalInfoFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRenewalNewTasksStart](state) {
        state.isLoading = true
        state.renewalList = null
    },
    [mutationTypes.getRenewalNewTasksSuccess](state, payload) {
        state.isLoading = false
        state.renewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getRenewalNewTasksFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getRenewalOverdueTasksStart](state) {
        state.isLoading = true
        state.renewalList = null
    },
    [mutationTypes.getRenewalOverdueTasksSuccess](state, payload) {
        state.isLoading = false
        state.renewalList = payload
        state.validationErrors = null
    },
    [mutationTypes.getRenewalOverdueTasksFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getDealsStageRenewalStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getDealsStageRenewalSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getDealsStageRenewalFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [renewalActionTypes.getPackageNodeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getPackageNodealsStart)
            renewalApi
                .getPackageNodeals(data)
                .then(response => {
                    context.commit(mutationTypes.getPackageNodealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getPackageNodealsFailure,response)
                })
        })
    },

    [renewalActionTypes.getMembershipNodeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getMembershipNodealsStart)
            renewalApi
                .getMembershipNodeals(data)
                .then(response => {
                    context.commit(mutationTypes.getMembershipNodealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getMembershipNodealsFailure,response)
                })
        })
    },

    [renewalActionTypes.getPackageExtension](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getPackageExtensionStart)
            renewalApi
                .getPackageExtension(data)
                .then(response => {
                    context.commit(mutationTypes.getPackageExtensionSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getPackageExtensionFailure,response)
                })
        })
    },

    [renewalActionTypes.getMembershipExtension](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getMembershipExtensionStart)
            renewalApi
                .getMembershipExtension(data)
                .then(response => {
                    context.commit(mutationTypes.getMembershipExtensionSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getMembershipExtensionFailure,response)
                })
        })
    },

    [renewalActionTypes.getRenewalNotaskDeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRenewalNotaskDealsStart)
            renewalApi
                .getNotaskDeals(data)
                .then(response => {
                    context.commit(mutationTypes.getRenewalNotaskDealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRenewalNotaskDealsFailure,response)
                })
        })
    },

    [renewalActionTypes.getRenewalActiveDeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRenewalActiveDealsStart)
            renewalApi
                .getActiveDeals(data)
                .then(response => {
                    context.commit(mutationTypes.getRenewalActiveDealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRenewalActiveDealsFailure,response)
                })
        })
    },

    [renewalActionTypes.getRenewalInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRenewalInfoStart)
            renewalApi
                .getRenewalInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getRenewalInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRenewalInfoFailure, response)
                })
        })
    },

    [renewalActionTypes.getRenewalNewTasks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRenewalNewTasksStart)
            renewalApi
                .getRenewalNewTasks(data)
                .then(response => {
                    context.commit(mutationTypes.getRenewalNewTasksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRenewalNewTasksFailure,response)
                })
        })
    },

    [renewalActionTypes.getRenewalOverdueTasks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getRenewalOverdueTasksStart)
            renewalApi
                .getRenewalOverdueTasks(data)
                .then(response => {
                    context.commit(mutationTypes.getRenewalOverdueTasksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getRenewalOverdueTasksFailure,response)
                })
        })
    },

    [renewalActionTypes.getDealsStageRenewal](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getDealsStageRenewalStart)
            renewalApi
                .getDealsStageRenewal(data)
                .then(response => {
                    context.commit(mutationTypes.getDealsStageRenewalSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getDealsStageRenewalFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}